import api from "@services/api";

export const getZoneAccountById = async (id: string) => {
  const { data } = await api.get(`/zoneAccounts/${id}`);
  return data;
};
